.left-section {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: var(--blue-xlt);
    width: 100%;
}
